import React from "react";
import ToolTip from "components/ToolTip";

const TwoRowDownSingle = ({ className = "", lClassName = "", rClassName = "", left = "", right = "", rClick = () => {} }) => {
    return (
        <div className={`d-grid ${className}`}>
            <span className={`d-inline-block ${lClassName}`}>{left}</span>
            <span onClick={rClick} className={`d-inline-block ${rClassName}`}>
                {typeof right === "function" ? right() : right}
            </span>
            <ToolTip id="two-row-down-single" />
        </div>
    );
};

export default TwoRowDownSingle;
